module.exports = __webpack_public_path__ + "static/media/cookieMarkerLegacyPin.262eee33.svg";